<template>
  <section v-if="haveFissionAcitivity">
    <section
      :class="['activity-popup-wrapper', fissionGame, displayLayout]"
      v-if="isDisplayFissionEntry && hasHigherPriority"
    >
      <van-popup
        v-model="showPopupTypeFlag"
        class="activity-fission-popup"
        :close-on-click-overlay="false"
      >
        <section
          :class="[
            'popup-body',
            isOwner ? 'isOwner' : 'isGuest',
            giftCardNumberClassName,
          ]"
        >
          <div class="main-content-wrapper">
            <!-- 头部banner -->
            <common-header
              :type="isOwner ? 'isOwner' : 'isGuest'"
              :awards="registerAwardsNum"
              :shareAward="shareAwards.awardCount || 0"
              :loginAward="registerAwards.awardCount || 0"
              :everyOneMaxAwardNum="everyOneMaxAwardNum"
              :swipeList="swipeList"
            />
            <!-- 卡片 -->
            <section class="giftCard-wrapper" v-if="isOwner">
              <gift-card
                type="popup"
                :dataSource="awardList"
                :hasBgColor="false"
                cardType="popup-card"
                @className="getClassName"
              />
            </section>
          </div>
          <!-- gg、fb登录按钮 -->
          <login-btn
            v-if="showLoginBtn || showLoginBtnToGuest"
            @click="goLogin"
            type="popup"
            :class="[
              giftCardNumberClassName,
              'popup-card',
              showLoginBtnToGuest ? 'guest-popup' : '',
            ]"
          />

          <!-- 注册按钮：调起登录按钮面板 -->
          <common-btn
            v-if="showRegisterBtnToGuest"
            :btnText="$t('fission.go-to-register')"
            @click="goRegister"
            type="popup"
            class="registerBtn"
            :hasTips="true"
            :tipsText="$t('fission.register-rules2')"
            registerAwardsType="coupon"
            :registerAwardsNum="registerAwardsNum"
            :couponType="couponType"
            btnType="register"
          />
        </section>
        <div class="close-wrapper" @click="closePopup">
          <span class="iconfont icon-cancel"></span>
        </div>
      </van-popup>
      <SharerPopup
        v-if="!showPopupTypeFlag && showPopup && isOwner"
        @toLogin="goLogin"
        @opened="popupOpened"
        @closed="popupClosed"
      />
      <ShareePopup
        v-if="!showPopupTypeFlag && showPopup && isGuest"
        @toLogin="goRegister"
        @opened="popupOpened"
        @closed="popupClosed"
      />
      <!-- 弹框关闭后在页面右侧出现的悬浮活动入口，可移动 -->
      <!-- 20220509首页不再展示活动入口 -->
      <Parachute
        @click="openPopup(1)"
        @animationstart="animationstart"
        @animationend="animationend"
        v-if="showActivityEntryType && showActivityEntryType === 'parachute'"
      />
      <move-animation
        v-if="showActivityEntryType && showActivityEntryType === 'image'"
        :initY="200"
      >
        <img
          v-if="!!floatEntryImage"
          v-lazy="floatEntryImage"
          class="floatEntryImage"
          @click="openPopup"
          alt="logo"
        />
      </move-animation>
      <!-- 登录面板 -->
      <!-- <CommonLogin v-if="!loginStatus" ref="commonLogin" page="fission" /> -->
    </section>
    <owner-popup
      ref="ownerPopup"
      @closed="closeOwnerPopup"
      :popupOpenType="popupOpenType"
      :gameName="fissionGame"
      :activityId="activityId"
    />
  </section>
</template>
<script>
  import GiftCard from '../components/GiftCard'
  import { LoginBtn } from '../components/CommonBtns/index.js'
  import { mapState, mapGetters, mapMutations } from 'vuex'
  import { getActivityList, getUserPoints, getCouponList } from '@/api/fission'
  import { stringToJson } from '@/utils/tool'
  // import CommonLogin from '@/components/LoginBtn'
  import CommonBtn from '../components/CommonBtns/index.vue'
  import MoveAnimation from '@/components/MoveAnimation'
  import OwnerPopup from '../Home/Popup'
  import {
    showFissionPopup,
    storage,
    showFissionPopupTime,
    showFissionNologinPopup,
    showFissionNologinPopupTime,
    fissionGuest2OwnerInfos,
    backPageShowFissionPopup,
    fissionParachuteCount,
    fissionParachuteTime,
    fissionParachuteTodayFlag,
  } from '@/utils/storage'
  import {
    fission_popup,
    login_quick,
    login_quick_success,
    fission_shared_popup,
  } from '../firebase'
  import CommonHeader from './CommonHeader'
  import { is_display_fission_entry } from '@/utils/abtest'
  import { loadImages } from '@/utils/image'
  import { PQ, Message } from '@/utils/priorityQueue'
  import { getQuery } from '@/utils/utils'
  import {
    fissionGuestPopupDisplayMode,
    pubgm_fission_noLoginPopup_sharer,
    pubgm_fission_noLoginPopup_sharee,
  } from '@/utils/abtest'
  import { pagePopupShow, pagePopupClick } from '@/pages/marketingFirebase.js'
  import { LOGIN_TYPE } from '@/consts/index'
  import Parachute from '../components/Parachute'
  import SharerPopup from './SharerPopup'
  import ShareePopup from './ShareePopup'

  const popup_id = 'fission-popup'
  const parachute_popup_id = 'fission-parachute-popup'

  export default {
    components: {
      GiftCard,
      // CommonLogin,
      LoginBtn,
      CommonBtn,
      MoveAnimation,
      OwnerPopup,
      CommonHeader,
      Parachute,
      SharerPopup,
      ShareePopup,
    },
    props: {
      activeBanner: {
        type: Object,
        default: () => {},
      },
      page: {
        default: '',
        type: String,
      },
    },
    data() {
      return {
        hasHigherPriority: false, // 标记活动类型中的优先级高低
        showPopup: false,
        activityConfigDatas: {},
        showFloatEntry: false, // 右侧悬浮活动入口, 只有在登录的情况下才会展示
        manualClosePopup: false, // 手动关闭弹框
        userPoints: {},
        popupOpenType: 'auto', // 弹框打开类型，埋点用
        showOwerPopup: false,
        registerAwardsType: '', //注册获奖类型： 优惠券、游戏商品
        registerAwardsNum: '', //注册奖励数量
        couponType: 0, //注册奖励优惠券类型：1：立减券 2：折扣券
        shareAwards: {},
        registerAwards: {},
        everyOneMaxAwardNum: 0,
        couponList: [], // splitActivityConditionList 中 couponId 的集合，并标记其原始位置
        awardList: [], // 整合优惠券信息后的奖品列表
        giftCardNumberClassName: '',
        activitySource: getQuery('activitySource') || getQuery('source'), // 优先取 activitySource
        showParachuteEntryEnd: false,
        showActivityEntryType: '',
        isNotNewPopup: false,
      }
    },
    computed: {
      ...mapState([
        'region',
        'userInfo',
        'couponDisplayStatus',
        'gameName',
        'fissionGame',
      ]),
      ...mapGetters(['displayLayout']),
      activityId() {
        const { activityConfigDatas } = this
        return activityConfigDatas?.activityId || ''
      },
      awardCardDatas() {
        const { activityConfigDatas } = this
        return activityConfigDatas?.extraInfo?.splitActivityConditionList || []
      },
      // 右侧活动入口图标
      floatEntryImage() {
        const { activityConfigDatas } = this
        const url = activityConfigDatas?.extraInfo?.notLoginTipPic || ''
        return this.$options.filters['formatImgUrl'](url)
      },
      // 登录状态
      loginStatus() {
        if (
          this.userInfo &&
          this.userInfo.kicoinId &&
          this.userInfo.kicoinToken
        ) {
          return true
        }
        return false
      },
      // 分享者未登录弹框的轮播数据
      swipeList() {
        const { activityConfigDatas } = this
        const list =
          activityConfigDatas?.extraInfo?.carouselData?.split('\n') || []
        return list
      },
      // 显示注册按钮，点击调起登录面板,且没有手动关闭和没有从右侧悬浮框进入过, 且是被分享者时
      showRegisterBtn() {
        return !!(
          !this.loginStatus &&
          !this.manualClosePopup &&
          !this.showFloatEntry &&
          this.isGuest
        )
      },
      // 显示登录按钮：没有登录，没有手动关闭弹框，并且又从右侧的悬浮框点击显示时，并且是自己时
      showLoginBtn() {
        return !!(
          !this.manualClosePopup &&
          !this.showFloatEntry &&
          !this.loginStatus &&
          this.isOwner
        )
      },
      // 是“我自己”，不是点击别人的分享链接进入的
      isOwner() {
        const { attachedKicoinId = '', activityId = '' } = this.$route.query
        const { kicoinId } = this.userInfo || {}
        if (this.loginStatus) {
          return (
            !attachedKicoinId || !activityId || attachedKicoinId === kicoinId
          )
        } else {
          return !attachedKicoinId || !activityId
        }
      },
      // 是“被分享者”，是点击别人的分享链接进入的
      isGuest() {
        const { attachedKicoinId = '', activityId = '' } = this.$route.query
        const { kicoinId } = this.userInfo || {}
        if (attachedKicoinId && activityId) {
          this.setFissionGuestInfos({
            attachedKicoinId,
            activityId,
          })

          storage.set(fissionGuest2OwnerInfos + this.suffix, {
            attachedKicoinId,
            activityId,
            time: +new Date(),
          })
        }

        if (this.loginStatus) {
          return !!(
            attachedKicoinId &&
            activityId &&
            attachedKicoinId !== kicoinId
          )
        } else {
          return !!(attachedKicoinId && activityId)
        }
      },
      // 是否有裂变活动
      haveFissionAcitivity() {
        const { activityConfigDatas = {} } = this
        return !!(activityConfigDatas && activityConfigDatas.activityId)
      },
      // 是否已经显示过裂变弹框标记
      showFissionPopupFlag() {
        // const showFlag = storage.get(showFissionPopup+ this.suffix)
        // const ts =
        //   ((+new Date() - storage.get(showFissionPopupTime+ this.suffix)) / 24) *
        //     60 *
        //     60 *
        //     1000 >
        //   24
        // return !!(showFlag && ts)
        // 2022-04-27: 登录后的裂变弹框只有在点击裂变的活动入口时才会展示，不需要在本地记录是否弹过了
        return true
      },
      // 分享者未登录的情况下是否已经显示过裂变弹框标记
      showFissionNologinPopupFlag() {
        const showFlag = storage.get(showFissionNologinPopup + this.suffix)
        const ts =
          ((+new Date() -
            storage.get(showFissionNologinPopupTime + this.suffix)) /
            24) *
            60 *
            60 *
            1000 >
          24
        return !!(showFlag && ts)
      },
      isDisplayFissionEntry() {
        return !!is_display_fission_entry()
      },
      backPageShowPopup() {
        return storage.get(backPageShowFissionPopup + this.suffix) * 1 === 1
      },
      suffix() {
        return `_${this.region}_${this.fissionGame}`
      },
      guestLoginPopupDisplayMode() {
        const mode = fissionGuestPopupDisplayMode()
        return mode
      },
      showLoginBtnToGuest() {
        return (
          (this.fissionGame === 'genshin' && !this.isOwner) ||
          (this.showRegisterBtn && this.guestLoginPopupDisplayMode === 2)
        )
      },
      showRegisterBtnToGuest() {
        return (
          this.fissionGame !== 'genshin' &&
          this.showRegisterBtn &&
          this.guestLoginPopupDisplayMode === 1
        )
      },
      showPopupTypeFlag() {
        const { fissionGame, showPopup, isOwner, isGuest, page } = this
        const abtest_sharer = pubgm_fission_noLoginPopup_sharer()
        const abtest_sharee = pubgm_fission_noLoginPopup_sharee()

        if (showPopup) {
          if (page === 'home') {
            return true
          }
          if (fissionGame === 'pubgm' && abtest_sharer && isOwner) {
            return false
          }
          if (fissionGame === 'pubgm' && abtest_sharee && isGuest) {
            return false
          }
          return true
        }
        return false
      },
      parachuteShowState() {
        const count = storage.get(fissionParachuteCount) || 0
        const time = storage.get(fissionParachuteTime) || +new Date()
        const todayFlag = storage.get(fissionParachuteTodayFlag) * 1 === 1
        const currentTime = +new Date()
        // 最多只展示3次
        if (count && count >= 3) {
          return false
        }
        // 一天只展示一次
        if (time && currentTime - time > 86400000) {
          storage.set(fissionParachuteTime, +new Date())
          // storage.set(fissionParachuteCount, 0)
          storage.set(fissionParachuteTodayFlag, 1)
          return true
        } else {
          if (todayFlag) {
            // storage.set(fissionParachuteTodayFlag, 0)
            return false
          } else {
            storage.set(fissionParachuteTime, +new Date())
            storage.set(fissionParachuteTodayFlag, 1)
            return true
          }
        }
      },
    },
    watch: {
      showFloatEntry(val) {
        // 裂变活动入口曝光
        val &&
          pagePopupShow({
            page: this.gameName || 'home',
            list_id: '',
            act_id: this.activityId, // 活动编号
            popup_type: 'toast',
          })

        if (val) {
          const { fissionGame, isOwner } = this
          const abtest = pubgm_fission_noLoginPopup_sharer()
          const showParachute = fissionGame === 'pubgm' && abtest && isOwner
          const {
            showFloatEntry,
            floatEntryImage,
            showParachuteEntryEnd,
            parachuteShowState,
          } = this
          if (showFloatEntry) {
            if (parachuteShowState && showParachute) {
              if (!showParachuteEntryEnd) {
                // this.showActivityEntryType = 'parachute' // 降落伞入口
                const timeid = setTimeout(() => {
                  PQ.enqueue({
                    id: parachute_popup_id,
                    priority: 3.1, // 在优惠券弹框后弹出
                  })
                  clearTimeout(timeid)
                }, 1200)
              }
            } else {
              if (floatEntryImage) {
                this.showActivityEntryType = 'image' // 图片入口
              }
            }
          }
        }
      },
      showOwerPopup(val) {
        if (val) {
          this.$refs.ownerPopup && this.$refs.ownerPopup.showSwitch()
          // this.showFloatEntry = false
          this.showPopup = false
          fission_popup({
            page: 'fission-popup',
            from: this.popupOpenType,
          })
        }
      },
      showPopup(val) {
        if (val) {
          if (this.isGuest) {
            fission_shared_popup({
              page: 'fission-popup',
            })
            // 裂变助力者弹窗曝光
            pagePopupShow({
              page: this.gameName || 'home',
              list_id: '',
              act_id: this.activityId, // 活动编号
              popup_type: 'shared',
            })
          }
          if (this.isOwner) {
            fission_popup({
              page: 'fission-popup',
              from: this.popupOpenType,
            })
            this.setShowFissionNoLoginPopupFlag(true)

            // 裂变分享者弹窗曝光
            pagePopupShow({
              page: this.gameName || 'home',
              list_id: '',
              act_id: this.activityId, // 活动编号
              popup_type: 'sharer',
            })
          }
          PQ.open(popup_id)
        } else {
          PQ.close(popup_id)
        }
      },
      // userInfo(infos) {
      //   if (infos && infos.kicoinId && this.hasHigherPriority) {
      //     // 务必加上 hasHigherPriority 判断，防止重复上报该点
      //     login_quick_success({
      //       page: 'fission-popup',
      //       login_way: LOGIN_TYPE[infos.loginType * 1],
      //       mode: infos.userStatus || 0,
      //       button: this.isOwner ? 'fission' : 'shared',
      //       from: this.popupOpenType,
      //     })
      //     this.showPopup = false
      //     this.showFloatEntry = true
      //   }
      // },
      userInfo: {
        handler(infos) {
          if (infos && infos.kicoinId && this.hasHigherPriority) {
            // 务必加上 hasHigherPriority 判断，防止重复上报该点
            login_quick_success({
              page: 'fission-popup',
              login_way: LOGIN_TYPE[infos.loginType * 1],
              mode: infos.userStatus || 0,
              button: this.isOwner ? 'fission' : 'shared',
              from: this.popupOpenType,
            })
            this.showPopup = false
            this.showFloatEntry = true
          }
          this.getAcitivityInfos()
        },
        deep: true,
        immediate: true,
      },
    },
    mounted() {
      // this.getAcitivityInfos()
    },
    methods: {
      ...mapMutations([
        'setFissionInfos',
        'setFissionGuestInfos',
        'setFissionGameName',
        'detail/setIsPierceLogoLayer',
        'detail/setTuneUpLogin',
      ]),
      closePopup() {
        this.showPopup = false
        this.showFloatEntry = this.loginStatus
        this.manualClosePopup = !this.manualClosePopup
      },
      closeOwnerPopup() {
        this.showFloatEntry = !this.showFloatEntry && this.loginStatus
        this.manualClosePopup = !this.manualClosePopup
        this.showOwerPopup = false
        this.setShowFissionPopupFlag(true)
      },
      openPopup(type) {
        if (this.loginStatus) {
          this.$refs.ownerPopup && this.$refs.ownerPopup.showSwitch()
        }
        this.showFloatEntry = false
        this.popupOpenType = 'popup'
        fission_popup({
          page: 'fission-popup',
          from: this.popupOpenType,
        })
        pagePopupClick({
          page: this.gameName,
          act_id: this.activityId,
        })
        if (type === 1) {
          this.animationend()
          storage.set(fissionParachuteCount, 4)
        }
      },
      getAcitivityInfos() {
        if (!this.isDisplayFissionEntry && !this.showFloatEntry) {
          return
        }
        let params = {
          game: this.gameName,
          country: this.region,
          // activityType: 4, // 不传递该值则返回现有的活动
          queryOnline: 1, // 只查询在线活动
          activitySource: this.activitySource,
        }
        if (this.activeBanner) {
          let activityIdString = this.activeBanner.activityId || ''
          activityIdString = window.decodeURIComponent(activityIdString) || ''
          activityIdString = activityIdString.split('?')[0]
          params = {
            ...params,
            activityIdString,
          }
        }
        getActivityList(params).then((res) => {
          if (res) {
            const activity = res[0] || {} // 返回的第一条数据是优先级最高的
            this.hasHigherPriority = activity.activityType * 1 === 4 // 只有符合当前活动类型的数据才展示
            if (!this.hasHigherPriority) {
              return
            }
            if (activity && activity.extraInfo) {
              activity.extraInfo = stringToJson(activity.extraInfo)
            }

            this.activityConfigDatas = activity
            this.setFissionInfos(activity)
            this.setFissionGameName(activity.game)
            // 获取优惠券信息
            this.awardList = this.awardCardDatas
            const couponIdString = this.getCouponIdString(
              this.activityConfigDatas?.extraInfo?.splitActivityConditionList
            )
            this.handleCouponInfos(couponIdString)
            if (this.loginStatus) {
              this.getPoints(activity.activityId)
            }
            // 未登录弹框：如果是分享者每天只能弹一次，被分享者每次都弹
            // 二期优化需求：不再限制弹框弹出次数了，每次访问都会弹窗
            this.$nextTick(() => {
              const timeid = setTimeout(() => {
                if (this.isGuest) {
                  if (activity.activityId && !this.loginStatus) {
                    PQ.enqueue({
                      id: popup_id,
                      priority: 5,
                    })
                  }
                } else {
                  if (
                    activity.activityId &&
                    !this.loginStatus &&
                    !this.showFissionNologinPopupFlag
                  ) {
                    PQ.enqueue({
                      id: popup_id,
                      priority: 5,
                    })
                  }
                }
                clearTimeout(timeid)
              }, 300)
            })

            // 未登录弹框：如果是分享者每天只能弹一次，被分享者每次都弹
            // 二期优化需求：不再限制弹框弹出次数了，每次访问都会弹窗
            let firstCallTs = 0
            Message.receive((res) => {
              const { id } = res || {}
              if (id === popup_id) {
                if (this.isGuest) {
                  this.showPopup = !!(activity.activityId && !this.loginStatus)
                } else {
                  // 延迟3s执行
                  if (firstCallTs && +new Date() - firstCallTs >= 3000) {
                    this.showPopup = !!(
                      activity.activityId &&
                      !this.loginStatus &&
                      !this.showFissionNologinPopupFlag
                    )
                    firstCallTs = 0
                  } else {
                    if (!firstCallTs) {
                      firstCallTs = +new Date()
                    }
                  }
                }
              }
              if (parachute_popup_id === id) {
                this.showActivityEntryType = 'parachute' // 降落伞入口
              }
            })
            // 已经弹过窗 & 活动存在 & 已登录 ==> 需要展示悬浮入口
            this.showFloatEntry =
              this.showFissionPopupFlag &&
              activity.activityId &&
              this.loginStatus

            this.showOwerPopup =
              this.loginStatus &&
              this.haveFissionAcitivity &&
              // !this.showFissionPopupFlag &&
              this.backPageShowPopup

            storage.set(backPageShowFissionPopup + this.suffix, 0)
            this.computedAwards(activity)
            this.preLoadImages()
          }
        })
      },
      // 去注册，调起登录面板
      goRegister() {
        // this.$refs.commonLogin && this.$refs.commonLogin.loginBtn()
        this.callLogin()
      },
      // 调起登录弹层
      callLogin() {
        const start = Date.now()
        this['detail/setIsPierceLogoLayer'](start)
      },

      // 登录
      goLogin(type) {
        const { activityId = '' } = this.activityConfigDatas || {}
        login_quick({
          login_way: type,
          button: this.isOwner ? 'fission' : 'shared',
          from: this.popupOpenType,
        })

        this['detail/setTuneUpLogin']({
          type,
          option: {
            button: activityId || 'fission',
          },
        })
        // if (type === 'vk') {
        //   this.$refs.commonLogin &&
        //     this.$refs.commonLogin.loginVK({
        //       button: activityId || 'fission',
        //     })
        // } else {
        //   this.$refs.commonLogin &&
        //     this.$refs.commonLogin.login(type, '', {
        //       button: activityId || 'fission',
        //     })
        // }
      },
      // 存储裂变弹框标记
      setShowFissionPopupFlag(value) {
        storage.set(showFissionPopup + this.suffix, value)
        storage.set(showFissionPopupTime + this.suffix, +new Date())
      },
      // 存储裂变未登录弹框标记
      setShowFissionNoLoginPopupFlag(value) {
        storage.set(showFissionNologinPopup + this.suffix, value)
        storage.set(showFissionNologinPopupTime + this.suffix, +new Date())
      },
      // 用户积分
      getPoints(activityId) {
        if (!activityId) {
          return
        }
        getUserPoints({
          game: this.gameName,
          country: this.region,
          activityId,
          source: this.activitySource,
        }).then((res) => {
          this.userPoints = res || {}
        })
      },
      // 计算用户所得奖励
      async computedAwards(activity) {
        const { extraInfo } = activity || {}
        const { splitActivityConditionList = [] } = extraInfo || {}
        // 注册奖励
        const registerAwards = this.getConfigInfos(
          splitActivityConditionList,
          3
        )
        this.registerAwards = registerAwards
        // 分享奖励
        const shareAwards = this.getConfigInfos(splitActivityConditionList, 2)
        this.shareAwards = shareAwards
        const { awardType, awardCount, couponId } = registerAwards
        // 3：优惠券 4：游戏商品
        if (awardType === 3) {
          // 获取优惠券信息
          const counponInfos = await this.getCouponInfos(couponId)
          const { couponType, discountMoney } = counponInfos || {}
          this.registerAwardsType = 'coupon'
          this.registerAwardsNum = discountMoney
          this.couponType = couponType
        }
        if (awardType === 4) {
          this.registerAwardsType = 'point'
          this.registerAwardsNum = awardCount
        }
        this.getEveryOneMaxAwardNum(splitActivityConditionList)
      },
      getConfigInfos(datas = [], type) {
        return (
          (datas.filter((item) => item.conditionType * 1 === type) || [])[0] ||
          {}
        )
      },
      getCouponInfos(couponId) {
        getCouponList({
          country: this.region,
          couponIdString: couponId,
        }).then((res) => {
          if (res && res.length) {
            // 取第一张优惠券
            const couponInfos = res[0] || {}
            const { couponType, couponPrice, couponDiscount } = couponInfos
            // 1 立减券 2折扣券
            let discountMoney = 0
            if (couponType * 1 === 1) {
              discountMoney = couponPrice
            }
            if (couponType * 1 === 2) {
              discountMoney = 100 - couponDiscount * 1
            }
            return Promise.resolve({
              couponType,
              discountMoney,
            })
          }
          return Promise.resolve({})
        })
      },
      getEveryOneMaxAwardNum(datas) {
        // 初始奖励
        const initConfigInfos = this.getConfigInfos(datas, 1)
        // 分享
        const shareConfigInfos = this.getConfigInfos(datas, 2)
        this.shareConfigInfos = shareConfigInfos
        // 注册
        const loginConfigInfos = this.getConfigInfos(datas, 3)
        // 付费
        const paymentConfigInfos = this.getConfigInfos(datas, 4)
        const paymentedConfigInfos = this.getConfigInfos(datas, 5)
        const { awardCount: initAwards = 0 } = initConfigInfos
        const { awardCount: shareAwards = 0 } = shareConfigInfos
        const { awardCount: loginAwards = 0 } = loginConfigInfos
        const { awardCount: paymentCount = 0 } = paymentConfigInfos
        const { conditionCount = 0, awardCount: paymentAwards = 0 } =
          paymentedConfigInfos

        this.everyOneMaxAwardNum =
          initAwards +
          shareAwards +
          loginAwards +
          paymentCount * conditionCount +
          paymentAwards
      },
      getCouponIdString(list) {
        if (!list) return
        // 筛选优惠券奖品信息
        this.couponList = list
          .map((curr, index) => {
            if (
              [3, 4, 5].indexOf(curr.conditionType * 1) > -1 &&
              curr.awardType * 1 === 3
            ) {
              return {
                index,
                couponId: curr.couponId,
              }
            }
          })
          .filter((item) => item !== undefined)
        // 返回用逗号分隔的 couponId 字符串
        return this.couponList.map((item) => item.couponId).join(',')
      },
      async handleCouponInfos(couponIdString) {
        if (!couponIdString) return
        const res = await getCouponList({
          country: this.region,
          couponIdString,
        })
        // 合并优惠券数据到 awardCardDatas 中
        if (res && res.length > 0) {
          res.forEach((item, index) => {
            const order = this.couponList[index].index // 对应接口返回数据中的原始索引
            // 不要直接对 this.awardList[order] 直接赋值，否则在子组件中无法识别到数据变化
            this.awardList.splice(order, 1, {
              ...this.awardCardDatas[order],
              ...item,
            })
          })
        }
      },
      getClassName(res) {
        this.giftCardNumberClassName = res
      },
      // 提前加载图片防止图片抖动
      preLoadImages() {
        const srcs = [
          require(`@/assets/images/activities/fission/mobile-legends/coupon_bg.png`),
          require(`@/assets/images/activities/fission/mobile-legends/gift_bg.png`),
        ]
        loadImages(srcs)
      },
      animationend() {
        this.showParachuteEntryEnd = true
        this.showActivityEntryType = 'image'
        PQ.close(parachute_popup_id)
      },
      animationstart() {
        const count = storage.get(fissionParachuteCount)
        const time = storage.get(fissionParachuteTime)
        if (!count && !time) {
          storage.set(fissionParachuteTime, +new Date())
          storage.set(fissionParachuteCount, 1)
        }
        if (count <= 3) {
          storage.set(fissionParachuteCount, count * 1 + 1)
        }
      },
      popupOpened() {
        PQ.open(popup_id)
      },
      popupClosed() {
        PQ.close(popup_id)
      },
    },
  }
</script>
<style lang="scss" src="./index.scss"></style>
<style scoped>
  .activity-fission-popup
    >>> .popup-body
    >>> .public-page-wrapper
    .public-page-body
    >>> .progressBar-wrapper {
    margin-top: 21px;
  }
</style>
